// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"82044b9c","70":"60bcf79c","173":"358fe859","284":"69416b6c","318":"8fec3da4","388":"fa77437a","440":"11eb426a","757":"1b5a678f"}[chunkId] + ".chunk.js";
};